import { Formio, Components } from 'formiojs';
import { BarcodeReaderComponent } from './barcode-reader.component';

// Register with Formio
Formio.use({
  components: {
    barcodereader: BarcodeReaderComponent
  }
});

// Also register directly with Components
if (Components && (Components as any).components) {
  (Components as any).components.barcodereader = BarcodeReaderComponent;
  console.log('Barcode Reader component registered directly with Components');
}

console.log('Barcode Reader FormIO registration completed');